module.exports = __webpack_public_path__ + "static/media/thaikkudam.e50973d0.png";